/* =========================================================
   Tool 3：推薦語代理
   輸入：mbtiType（例如 "INFP"）
   輸出：隨機抽取一句推薦語字串
========================================================= */

const MESSAGES = {
  INTJ: [
    '今天適合在深夜獨自聆聽這首...',
    '這首歌的結構，你一定能聽懂它的邏輯之美',
    '當世界太吵，這首給你一個安靜的角落',
  ],
  INTP: [
    '這是一首你可能還沒發現的寶藏歌曲',
    '挖掘這首歌的細節，你會找到驚喜',
    '這首歌值得你反覆研究每一個音符',
  ],
  ENTJ: [
    '今天需要能量嗎？這首為你充電',
    '這首歌的氣場和你一樣強大',
    '播放它，然後去征服今天的目標',
  ],
  ENTP: [
    '這首歌有點怪，但你會愛上它',
    '挑戰你的音樂邊界，從這首開始',
    '這首歌的概念，你一定有話想說',
  ],
  INFJ: [
    '這首歌說出了你說不出口的話',
    '今晚靜下來，讓這首歌說話',
    '這是一首懂你的歌',
  ],
  INFP: [
    '這首歌會讓你在腦海裡展開一部電影',
    '今天適合用這首歌做夢',
    '這首歌是為你這樣的靈魂而存在的',
  ],
  ENFJ: [
    '這首歌，你一定要分享給你在乎的人',
    '用這首歌溫暖今天遇見的每一個人',
    '這首歌像你一樣，充滿溫度',
  ],
  ENFP: [
    '跟著這首歌跳起來吧！',
    '今天的心情配這首剛好',
    '你的能量和這首歌一樣停不下來',
  ],
  ISTJ: [
    '這首歌值得你加入固定歌單',
    '經典就是經典，這首你會聽很多遍',
    '穩定可靠，就像你一樣，這首歌也是',
  ],
  ISFJ: [
    '這首歌會讓你想起某個珍貴的人',
    '今晚泡杯茶，配上這首歌',
    '這首歌輕輕地陪著你，就夠了',
  ],
  ESTJ: [
    '這首歌讓你的效率直接翻倍',
    '工作時播這首，你會更專注',
    '這首歌的節奏就是你今天的步調',
  ],
  ESFJ: [
    '這首歌大家都在聽，你也來聽聽！',
    '一起唱這首，今天更快樂',
    '這首歌讓所有人都笑起來',
  ],
  ISTP: [
    '這首很酷，不解釋',
    '你的品味讓你找到了這首',
    '低調但有質感，就像你選歌的方式',
  ],
  ISFP: [
    '閉上眼睛，感受這首歌的每一個細節',
    '這首歌的聲音質地，你會懂的',
    '用耳機聽這首，美感翻倍',
  ],
  ESTP: [
    '這首讓你動起來的節奏停不下來',
    'Bass 夠重，適合你今天的狀態',
    '這首歌的能量和你一樣滿出來',
  ],
  ESFP: [
    '今天就是要跳舞！就這首！',
    '播這首，把快樂傳染給身邊的人',
    '你的派對能量配這首，完美',
  ],
};

export function messageTool(mbtiType) {
  const msgs = MESSAGES[mbtiType] || MESSAGES['INFP'];
  return msgs[Math.floor(Math.random() * msgs.length)];
}
